<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  import type { FliteImage, Link as LinkType } from "$lib/gql/genCms/codegen";
  import Container from "../Container/Container.svelte";
  import Button from "../Button/Button.svelte";
  import { processInlineLinks } from "$lib/utils/url";
  import Picture from "../Picture/Picture.svelte";

  export let shopifyImgSrc = "";
  export let smImage: FliteImage = {};
  export let mdImage: FliteImage = {};
  export let lgImage: FliteImage = {};
  export let xlImage: FliteImage = {};
  export let imgAltText: string;
  export let title = "";
  export let subtitle = "";
  export let link1: LinkType = { text: "", href: "" };
  export let link2: LinkType = { text: "", href: "" };
  export let htmlSubtitle = false;
  export let titleCapitalise = true;
  export let headingElement = "h1";
  const imageConfig = {
    smSize: { width: 768, height: 480 },
    mdSize: { width: 1280, height: 480 },
    lgSize: { width: 1600, height: 560 },
    xlSize: { width: 2560, height: 560 },
  };
</script>

<style lang="scss">
  .hero {
    position: relative;
    border-bottom: 1px solid $background;

    @include retina {
      border-bottom: 0.5px solid $background;
    }

    &--titles {
      &__parent {
        position: relative;
      }
      &__wrapper {
        &:before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 240px;
          background-image: $dark-vertical;
          opacity: 0.3;
        }
      }
      &__container {
        bottom: 48px;
        position: absolute;

        @include breakpoint(md) {
          max-width: 460px;
        }

        @include breakpoint(lg) {
          bottom: 64px;
        }
      }
    }
    &--title {
      &__capitalise {
        text-transform: capitalize;
      }
    }
    &--links {
      &__container {
        padding: 24px 0 0 0;
        display: flex;
      }
    }
    &--link {
      margin-right: 24px;
    }

    &--picture {
      &__container {
        display: block;
        height: 480px;
        object-fit: cover;
        overflow: hidden;
        position: relative;

        @include breakpoint(lg) {
          height: 560px;
        }
      }
      &__wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        min-height: 480px;
        max-height: 480px;
        min-width: 768px;

        @include breakpoint(md) {
          min-width: 1280px;
        }

        @include breakpoint(lg) {
          min-width: 1600px;
          min-height: 560px;
          max-height: 560px;
        }

        @include breakpoint(xl) {
          min-width: 2560px;
          width: 100%;
        }
      }
    }
  }
</style>

<div class="hero" data-cs-override-id="hero">
  <div class="hero--picture__container">
    <div class="hero--picture__wrapper">
      {#if shopifyImgSrc}
        <Picture
          smImage={shopifyImgSrc}
          mdImage={shopifyImgSrc}
          {imageConfig}
          altText={imgAltText}
          cover={true}
          shopifyImage
        />
      {:else if smImage || mdImage || lgImage}
        <Picture
          smImage={smImage.uri}
          mdImage={mdImage.uri}
          lgImage={lgImage.uri}
          xlImage={xlImage.uri}
          {imageConfig}
          altText={imgAltText}
          cover={true}
        />
      {/if}
    </div>
  </div>

  {#if title}
    <div class="hero--titles__wrapper">
      <Container>
        <div class="hero--titles__parent">
          <div class="hero--titles__container">
            <div
              class="hero--title {titleCapitalise
                ? 'hero--title__capitalise'
                : ''}"
            >
              <Typography
                component={headingElement}
                variant="h1"
                theme="inverse-on-surface"
              >
                {title}
              </Typography>
            </div>
            {#if subtitle}
              <Typography
                component="p"
                variant="body1"
                theme="inverse-on-surface"
              >
                {#if htmlSubtitle}
                  {@html processInlineLinks(subtitle)}
                {:else}
                  {subtitle}
                {/if}
              </Typography>
            {/if}

            {#if link1 || link2}
              <div class="hero--links__container">
                {#if link1 && link1.href}
                  <div class="hero--link">
                    <Button primary href={link1.href} label={link1.text} />
                  </div>
                {/if}
                {#if link2 && link2.href}
                  <div class="hero--link">
                    <Button primary href={link2.href} label={link2.text} />
                  </div>
                {/if}
              </div>
            {/if}
          </div>
        </div>
      </Container>
    </div>
  {/if}
</div>
